<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="reviews" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="reviewId" [paginator]="showPaginator"
  [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true" currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" selectionMode="single" [(selection)]="review" (onRowSelect)="onRowSelect($event)"
  [loading]="loading" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true"
  [autoLayout]="true" [responsive]="true">
  <ng-template pTemplate="caption">
    @if (!reservationId) {
      <input type="text" pInputText placeholder="Search" (input)="pt.filterGlobal($event.target.value, 'contains')"
        style="width:auto;">
    }
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Reviews</h1>
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onNewReviewButtonClick()">New Review +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    @if (!reservationId) {
      <tr>
        <th [pSortableColumn]="'reviewId'">
          <p-sortIcon [field]="'reviewId'"></p-sortIcon>Id
        </th>
        <th [pSortableColumn]="'reviewSource'">
          <p-sortIcon [field]="'reviewSource'"></p-sortIcon>Source
        </th>
        <th [pSortableColumn]="'status'">
          <p-sortIcon [field]="'status'"></p-sortIcon>Status
        </th>
        <th [pSortableColumn]="'shortTermRentalVO.propertyCode'">
          <p-sortIcon [field]="'shortTermRentalVO.propertyCode'"></p-sortIcon>Property
        </th>
        <th >MR
        </th>
        <th >GR
        </th>
        <th >YR
        </th>
        <th [pSortableColumn]="'rating'">
          <p-sortIcon [field]="'rating'"></p-sortIcon>Stars
        </th>
        <th>
          Length
        </th>
        <th [pSortableColumn]="'title'">
          <p-sortIcon [field]="'title'"></p-sortIcon>Title
        </th>
        <th></th>
        <th [pSortableColumn]="'lastName'">
          <p-sortIcon [field]="'lastName'"></p-sortIcon>Name
        </th>
        <th [pSortableColumn]="'reviewDate'">
          <p-sortIcon [field]="'reviewDate'"></p-sortIcon>Received
        </th>
        <th [pSortableColumn]="'checkInDate'">
          <p-sortIcon [field]="'checkInDate'"></p-sortIcon>Arrival
        </th>
      </tr>
    }

    @if (reservationId) {
      <tr>
        <th>Id</th>
        <th>Source</th>
        <th>Status
        </th>
        <th>Property
        </th>
        <th>MR
        </th>
        <th>GR
        </th>
        <th>YR
        </th>
        <th>Stars
        </th>
        <th>
          Length
        </th>
        <th>Title
        </th>
        <th></th>
        <th>Name
        </th>
        <th>Received
        </th>
        <th>Arrival
        </th>
      </tr>
    }

    @if (!reservationId) {
      <tr>
        <td><input pInputText style="width:50px;" type="number"
        (input)="pt.filter($event.target.value, 'reviewId', 'in')"></td>
        <td>
          <p-dropdown [style]="{'min-width':'70px'}" [options]="reviewSources"
            (onChange)="pt.filter($event.value, 'reviewSource', 'in')" styleClass="p-column-filter"
            placeholder="All" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </td>
        <td>
          <p-dropdown [style]="{'min width':'50px'}" [options]="statuses"
            (onChange)="pt.filter($event.value, 'status', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </td>
        <td><input pInputText style="width:100px;" type="text"
        (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'in')"></td>
        <td></td>
        <td></td>
        <td></td>
        <td><input pInputText style="width:50px;" type="text"
        (input)="pt.filter($event.target.value, 'rating', 'in')"></td>
        <td></td>
        <td></td>
        <td></td>
        <td><input pInputText style="width:100px;" type="text"
        (input)="pt.filter($event.target.value, 'lastName', 'in')"></td>
        <td><input pInputText style="width:100px;" type="date"
        (input)="pt.filter($event.target.value, 'reviewDate', 'in')"></td>
        <td><input pInputText style="width:100px;" type="date"
        (input)="pt.filter($event.target.value, 'checkInDate', 'in')"></td>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-review>
    <tr [pSelectableRow]="review">
      <td>{{review.reviewId}}</td>
      <td>
        @if (review.reviewSource === 'VRBO') {
          <span class="p-tag p-tag-info">VRBO</span>
        }
        @if (review.reviewSource === 'KBM') {
          <span class="p-tag p-tag-success">KBM</span>
        }
        @if (!review.reviewSource) {
          <span class="p-tag p-tag-warning">KBM</span>
        }
      </td>
      @if (review.status==1) {
        <td style="color: grey;">{{getStatusName(review)}}</td>
      }
      @if (review.status==2) {
        <td style="color: blue;">{{getStatusName(review)}}</td>
      }
      @if (review.status==3) {
        <td style="color: green;">{{getStatusName(review)}}</td>
      }
      @if (review.status==4) {
        <td style="color: red;">{{getStatusName(review)}}</td>
      }

      <td>{{review.propertyCode}}</td>
      <!-- <td>{{review.responseDesc}}</td> -->
      <!-- <td *ngIf="review.responseDesc != undefined && review.responseDesc != null"><p-checkbox [(ngModel)]="selectedCategories" name="review.reviewId"  [ngModelOptions]="{standalone: true}" [value]="true" [binary]="true" inputId="binary" ></p-checkbox></td> -->
      <td ><p-checkbox [(ngModel)]="review.responseDescFlag" value="review.responseDescFlag" [binary]="review.responseDescFlag" readonly="true"></p-checkbox></td>
      <td ><p-checkbox [(ngModel)]="review.guestFollowupRequest" value="review.guestFollowupRequest" [binary]="review.guestFollowupRequest"></p-checkbox></td>
      <td ><p-checkbox [(ngModel)]="review.yelpReviewRequest" value="review.yelpReviewRequest" [binary]="review.yelpReviewRequest"></p-checkbox></td>

      <td>
        <p-rating [(ngModel)]="review.rating" readonly=true stars=5></p-rating>
      </td>
      <td>{{review?.reviewDesc?.length}}</td>
      <td class="fixdata"><b>{{review.title}}</b></td>
      <td>
        @if (review?.rating===5 && !review?.guestFollowupRequest && review.status != 4) {
          <span >
            @if (review?.emailAddress && msgIdList?.includes(review?.reviewId)) {
              <button style="max-width:200px;" class="mr-3 p-button-outlined p-button-info" pButton
              type="button" label="Send Again" (click)="sendPublicReviewRequestEmail(review)"></button>
            }
            @if (review?.emailAddress && !msgIdList?.includes(review?.reviewId)) {
              <button style="max-width:200px;" class="mr-3 p-button-outlined p-button-info" pButton
              type="button" label="Public Review Request" (click)="sendPublicReviewRequestEmail(review)"></button>
            }
          </span>
        }
        @if (review?.rating===5 && !review?.yelpReviewRequest && review.status === 3) {
          <span >
            @if (review?.emailAddress && yelpMsgIdList?.includes(review?.reviewId)) {
              <button style="max-width:200px;" class="mr-3 p-button-outlined p-button-info" pButton
              type="button" label="Send Again" (click)="sendYelpReviewRequestEmail(review)"></button>
            }
            @if (review?.emailAddress && !yelpMsgIdList?.includes(review?.reviewId)) {
              <button style="max-width:200px;" class="mr-3 p-button-outlined p-button-info" pButton
              type="button" label="Yelp Review Request" (click)="sendYelpReviewRequestEmail(review)"></button>
            }
          </span>
        }
      </td>
      <td>{{review.lastName}}</td>
      <td>{{review.reviewDate | date:'medium'  }}</td>
      <td>{{review.checkInDate | date:'shortDate'  }}</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} - {{recordTotal > 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows + lazyLoadEvent.first)
  : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
</p-table>
